// extracted by mini-css-extract-plugin
module.exports = {"minimalInfo":"internalProjectTemplateEdition_minimalInfo__ews41","item1":"internalProjectTemplateEdition_item1__BixPZ","item2":"internalProjectTemplateEdition_item2__sdGWF"};